import { render, staticRenderFns } from "./PerformanceActivitiesTotalSpendCustomers.vue?vue&type=template&id=1c897e28&scoped=true&"
import script from "./PerformanceActivitiesTotalSpendCustomers.vue?vue&type=script&lang=ts&"
export * from "./PerformanceActivitiesTotalSpendCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceActivitiesTotalSpendCustomers.vue?vue&type=style&index=0&id=1c897e28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c897e28",
  null
  
)

export default component.exports